import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "alt", "label", "onClick", "disabled"],
      _excluded2 = ["on", "off", "onLabel", "offLabel", "label", "alt", "active", "onClick", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { forwardRef } from 'react';
import { styled } from '@linaria/react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledIconButton = /*#__PURE__*/styled("button")({
  name: "StyledIconButton",
  class: "sqtdz8h",
  vars: {
    "sqtdz8h-0": [props => props.rotate ? "rotate(".concat(props.rotate, ")") : 'none'],
    "sqtdz8h-1": [props => props.rotate ? "scale(0.8) rotate(".concat(props.rotate, ")") : 'scale(0.8) ']
  }
});
export const DEFAULT_ICONBUTTON_LABEL = 'Unlabeled IconButton';
export const IconButton = /*#__PURE__*/forwardRef(function IconButtonInner(_ref, ref) {
  let {
    children = /*#__PURE__*/_jsx(_Fragment, {}),
    alt,
    label,
    onClick = () => {},
    disabled = false
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const actualLabel = alt || label || DEFAULT_ICONBUTTON_LABEL;
  return /*#__PURE__*/_jsxs(StyledIconButton, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    role: "button",
    "aria-label": actualLabel,
    tabIndex: 0,
    title: actualLabel,
    disabled: disabled,
    onClick: disabled === true ? () => {} : onClick,
    children: [children, /*#__PURE__*/_jsx("span", {
      className: "visually-hidden",
      children: label || alt || DEFAULT_ICONBUTTON_LABEL
    })]
  }));
});
export const IconToggleButton = /*#__PURE__*/forwardRef(function IconButtonInner(_ref2, ref) {
  let {
    on,
    off,
    onLabel = '',
    offLabel = '',
    label: labelInput,
    alt,
    active = false,
    onClick = () => {},
    disabled = false
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  let label = alt || labelInput || DEFAULT_ICONBUTTON_LABEL;

  if (onLabel && offLabel) {
    label = active == true ? onLabel : offLabel;
  }

  return /*#__PURE__*/_jsxs(StyledIconButton, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    role: "button",
    "aria-label": label,
    tabIndex: 0,
    title: label,
    disabled: disabled,
    onClick: disabled === true ? () => {} : onClick,
    children: [active === true && on, active === false && off, /*#__PURE__*/_jsx("span", {
      className: "visually-hidden",
      children: label || DEFAULT_ICONBUTTON_LABEL
    })]
  }));
});

require("./IconButton.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./IconButton.tsx");